import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";
import { generateQueryParams } from "../../utils/generateQueryParams";

// CLIENT THUNKS (existing)
export const getCompanyProfile = createAsyncThunk(
  "company/getCompanyProfile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/user/company-profile");
      console.log("Company profile fetched:", response.data);
      return response.data;
    } catch (err) {
      console.error("Error fetching company profile:", err);
      return rejectWithValue(err.response?.data?.message || "Failed to fetch company profile");
    }
  }
);

export const getCompanyProfileAdmin = createAsyncThunk(
  "company/admin/getCompanyProfile",
  async (companyId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/admin/companies/${companyId}/profile`);
      console.log("Admin: Company profile fetched:", response.data);
      return response.data;
    } catch (err) {
      console.error("Admin: Error fetching company profile:", err);
      return rejectWithValue(err.response?.data?.message || "Failed to fetch company profile");
    }
  }
);

export const updateCompanyProfile = createAsyncThunk(
  "company/updateCompanyProfile",
  async (companyData, { rejectWithValue }) => {
    try {
      const response = await api.put("/user/company-profile", companyData);
      console.log("Company profile updated:", response.data);
      return response.data;
    } catch (err) {
      console.error("Error updating company profile:", err);
      return rejectWithValue(err.response?.data?.message || "Failed to update company profile");
    }
  }
);

// ADMIN THUNKS
export const fetchAllCompanies = createAsyncThunk(
  "/admin/companies/all/fetchAllCompanies",
  async (params = {}) => {
      const queryString = generateQueryParams(params);
      const response = await api.get(
        `/admin/companies/all${queryString ? `?${queryString}` : ""}`
      );
      console.log("Admin: Fetched all companies response:", response.data);
      return response.data.data;
  }
);

export const deleteCompanyAdmin = createAsyncThunk(
  "company/admin/deleteCompany",
  async (companyId) => {
      // Make the delete request
      const response = await api.delete(`/admin/companies/${companyId}`);
      
      console.log("Thunk: Delete response:", response.data);
      
      // Return the company ID so the reducer can remove it from the state
      return {
        deletedCompanyId: companyId,
        success: true,
        message: response.data.message,
        ...response.data.data
      };
  }
);

export const fetchCompanyTeamMembers = createAsyncThunk(
  "company/admin/fetchCompanyTeamMembers",
  async (companyId, { rejectWithValue }) => {
    try {
      console.log("Thunk: Fetching team members for company:", companyId);
      
      if (!companyId) {
        return rejectWithValue("Company ID is required");
      }

      const response = await api.get(`/admin/companies/${companyId}/team-members`);

      console.log("Thunk: Fetched company team members:", response.data);
      
      return {
        companyId: companyId,
        teamMembers: response.data.data.teamMembers || [],
        ...response.data.data
      };
      
    } catch (error) {
      console.error("Thunk: Error fetching team members:", error);
      
      const errorMessage = error.response?.data?.message 
        || error.response?.data?.error 
        || error.message 
        || "Failed to fetch team members";
        
      return rejectWithValue(errorMessage);
    }
  }
);

export const deleteCompanyTeamMember = createAsyncThunk(
  "company/admin/deleteCompanyTeamMember",
  async ({ companyId, teamMemberId }) => {
    console.log("Thunk: Removing team member with ID:", { companyId, teamMemberId });

    // Make the delete request
    const response = await api.delete(`/admin/companies/${companyId}/members/${teamMemberId}`);
    return response.data;
  }
);

export const deleteTeamMemberClientAdmin = createAsyncThunk(
  "company/admin/deleteTeamMemberClient",
  async ({ companyId, teamMemberId }, { rejectWithValue }) => {
    try {
      console.log("Thunk: Removing team member with ID:", { companyId, teamMemberId });
      
      if (!companyId || !teamMemberId) {
        return rejectWithValue("Company ID and Team Member ID are required");
      }

      // Make the delete request
      const response = await api.delete(`/admin/companies/${companyId}/team-member-clients/${teamMemberId}`);
      
      console.log("Thunk: Remove team member response:", response.data);
      
      return {
        removedTeamMemberId: teamMemberId,
        companyId: companyId,
        success: true,
        message: response.data.message,
        ...response.data.data
      };
      
    } catch (error) {
      console.error("Thunk: Error removing team member:", error);
      
      const errorMessage = error.response?.data?.message 
        || error.response?.data?.error 
        || error.message 
        || "Failed to remove team member";
        
      return rejectWithValue(errorMessage);
    }
  }
);